module.exports = __webpack_public_path__ + "img/docx.8d3e5be3.png";